import { SIDES } from './table.consts';
import { MuiTableCell, styled, CSSObject, Theme } from '../base-components';
import { ITableStickyColumn } from './table.interfaces';
import { stickyStyles } from './table.utils';

const stickyDividerStyles = (theme: Theme, side: string): CSSObject => {
    return {
        content: "''",
        position: 'absolute',
        bottom: '0',
        left: side === SIDES.LEFT ? '100%' : undefined,
        right: side === SIDES.RIGHT ? '100%' : undefined,
        width: '2px',
        height: '100%',
        background: `${theme.palette.grey[500]}3D`,
        boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    };
};

export const baseCellStyles = (
    theme: Theme,
    stickyPosition: string | undefined,
    columnIndex: number | undefined,
    columnWidth: number | undefined,
    stickyWidths: Array<number> | undefined
): CSSObject => {
    const left =
        stickyPosition === SIDES.LEFT
            ? stickyWidths?.slice(0, columnIndex).reduce((a, b) => a + b, 0)
            : undefined;
    const right =
        stickyPosition === SIDES.RIGHT
            ? stickyWidths?.slice(0, columnIndex).reduce((a, b) => a + b, 0)
            : undefined;
    return {
        position: stickyPosition ? 'sticky' : undefined,
        left: left && left >= 0 ? `${left}px` : undefined,
        right: right && right >= 0 ? '0px' : undefined,
        zIndex: stickyPosition ? 1 : undefined,
        whiteSpace: 'nowrap',
        maxWidth: `${columnWidth}px`,
        minWidth: `${columnWidth}px`,
        '&::after':
            left && left >= 0
                ? {
                      ...stickyDividerStyles(theme, SIDES.LEFT),
                  }
                : undefined,

        '&::before':
            right && right >= 0
                ? {
                      ...stickyDividerStyles(theme, SIDES.RIGHT),
                  }
                : undefined,
        '&:last-child': {
            paddingInlineEnd: theme.spacing(3),
            paddingInlineStart: theme.spacing(2),
        },
    };
};

export const StyledTableCell = styled(MuiTableCell)<{
    alignment: string;
    columnIndex: number | undefined;
    stickyColumn?: ITableStickyColumn;
    rowStickyWidths?: Array<number>;
    isSelected?: boolean;
}>(({
    theme,
    alignment: alignment,
    stickyColumn: stickyColumn,
    rowStickyWidths: rowStickyWidths,
    columnIndex: columnIndex,
    isSelected: isSelected,
}) => {
    const hasStickyColumn = stickyColumn?.side && stickyColumn?.width;
    const stickyStylesObj = hasStickyColumn
        ? stickyStyles(
              theme,
              stickyColumn?.side,
              columnIndex,
              stickyColumn?.width,
              rowStickyWidths,
              false,
              isSelected
          )
        : {};
    return {
        ...stickyStylesObj,
        direction: `${alignment === 'right' ? 'rtl' : 'ltr'}`,
    };
});
